import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

const OuterButton = ({ value, className, icon, iconSize, iconClassName, text, textClassName }) => (
  <button
    type="button"
    className={cn(
      'flex h-[40px] cursor-pointer items-center gap-2 rounded-md border border-solid border-neutral-200 bg-white px-3',
      className
    )}>
    {icon && (
      <Icon icon={icon} size={iconSize} color="neutral" shade={700} className={iconClassName} />
    )}
    {text && (
      <span
        className={cn(
          'line-clamp-1 text-left text-sm text-neutral-500',
          value && 'text-neutral-700',
          textClassName
        )}
        title={text}>
        {text}
      </span>
    )}
  </button>
);

export default OuterButton;
